var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _rect342, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _rect349, _rect350, _rect351, _rect352, _rect353, _rect354, _rect355, _rect356, _rect357, _rect358, _rect359, _rect360, _rect361, _rect362, _rect363, _rect364, _rect365, _rect366, _rect367, _rect368, _rect369, _rect370, _rect371, _rect372, _rect373, _rect374, _rect375, _rect376, _rect377, _rect378, _rect379, _rect380, _rect381, _rect382, _rect383, _rect384, _rect385, _rect386, _rect387, _rect388, _rect389, _rect390, _rect391, _rect392, _rect393, _rect394, _rect395, _rect396, _rect397, _rect398, _rect399, _rect400, _rect401, _rect402, _rect403, _rect404, _rect405, _rect406, _rect407, _rect408, _rect409, _rect410, _rect411, _rect412, _rect413, _rect414, _rect415, _rect416, _rect417, _rect418, _rect419, _rect420, _rect421, _rect422, _rect423, _rect424, _rect425, _rect426, _rect427, _rect428, _rect429, _rect430, _rect431, _rect432, _rect433, _rect434, _rect435, _rect436, _rect437, _rect438, _rect439, _rect440, _rect441, _rect442, _rect443, _rect444, _rect445, _rect446, _rect447, _rect448, _rect449, _rect450, _rect451, _rect452, _rect453, _rect454, _rect455, _rect456, _rect457, _rect458, _rect459, _rect460, _rect461, _rect462, _rect463, _rect464, _rect465, _rect466, _rect467, _rect468, _rect469, _rect470;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4001,
    height: 1675,
    viewBox: "0 0 4001 1675",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1860.91,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#573823"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1953.96,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#563723"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2047,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#583726"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2140.04,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#5A341D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1767.86,
    y: 93.0459,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#583927"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1860.91,
    y: 93.0459,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#503721"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1953.96,
    y: 93.0459,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#593B23"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 2047,
    y: 93.0459,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#563A25"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 2140.04,
    y: 93.0459,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#503A22"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 2233.09,
    y: 93.0459,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#543D2B"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1209.59,
    y: 186.091,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#453617"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 1302.63,
    y: 186.091,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#463525"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 1395.68,
    y: 186.091,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4F2D21"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 1488.73,
    y: 186.091,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4A3019"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1581.77,
    y: 186.091,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#493220"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1674.82,
    y: 186.091,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#573C2B"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 1767.86,
    y: 186.091,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#55371D"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 1860.91,
    y: 186.091,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#543924"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 1953.96,
    y: 186.091,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6D4B30"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 2047,
    y: 186.091,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#563A25"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 2140.04,
    y: 186.091,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#5A3724"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 2233.09,
    y: 186.091,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4F3921"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 2326.14,
    y: 186.091,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#492D1F"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 2419.18,
    y: 186.091,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#493224"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 2512.23,
    y: 186.091,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4C2E23"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 2605.27,
    y: 186.091,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#483227"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 2698.32,
    y: 186.091,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#47331B"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 930.455,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#43311D"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 1023.5,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#3C301A"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 1116.55,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#462F1D"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 1209.59,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#483322"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 1302.63,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#724F33"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 1395.68,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#492D17"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 1488.73,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#483121"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 1581.77,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#483121"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 1674.82,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#573826"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 1767.86,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6F4D32"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 1860.91,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#563A24"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 1953.96,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#67472E"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 2047,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#543823"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 2140.04,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#573823"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 2233.09,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#54361E"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 2326.14,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#523925"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 2419.18,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#462E22"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 2512.23,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#422915"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 2605.27,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#654933"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 2698.32,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4D321F"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 2791.37,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4A3426"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 2884.41,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4C3025"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 2977.45,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#472B1F"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 3070.5,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#442F1E"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 3163.54,
    y: 279.137,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#472B1F"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 558.271,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#432C1C"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 651.318,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#472A26"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 744.363,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4B2620"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 837.408,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4A2E23"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 930.455,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4E3224"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 1023.5,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#52321B"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 1116.55,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#422C1E"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 1209.59,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#493423"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 1302.63,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#473123"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 1395.68,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4A3426"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 1488.73,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#493125"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 1581.77,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#473022"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 1674.82,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#583925"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 1767.86,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#5A3A21"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 1860.91,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#5B3C27"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 1953.96,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6E4C33"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 2047,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#583927"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 2140.04,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#563722"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 2233.09,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#704B30"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 2326.14,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#563A25"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 2419.18,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#473022"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 2512.23,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#472F23"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 2605.27,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4A3023"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 2698.32,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4F3421"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 2791.37,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#483123"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 2884.41,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#473022"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 2977.45,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#583C27"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 3070.5,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4D2C1D"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 3163.54,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#443224"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 3256.59,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#44281C"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 3349.64,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#43221B"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 3442.68,
    y: 372.182,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#43221B"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 279.136,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#542D28"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 372.184,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#472E27"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 465.227,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#422E23"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 558.271,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#5D442E"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 651.318,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#705037"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 744.363,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6D4E39"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 837.408,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#422F20"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 930.455,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#452E20"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 1023.5,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6E4F33"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 1116.55,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#735233"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 1209.59,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#432D1F"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 1302.63,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#483024"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 1395.68,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#493125"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 1488.73,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#493125"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 1581.77,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#492E1D"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 1674.82,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#563A25"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 1767.86,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#553924"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 1860.91,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#563927"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 1953.96,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#593922"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 2047,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#5A3B26"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 2140.04,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#563A24"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 2233.09,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#5A3A23"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 2326.14,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#583925"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 2419.18,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#492F22"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 2512.23,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4B3025"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 2605.27,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4B3025"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 2698.32,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#473328"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 2791.37,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#423022"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 2884.41,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#493125"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 2977.45,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4A2D1B"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 3070.5,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#60412C"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 3163.54,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6C4A31"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 3256.59,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6D4E32"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 3349.64,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#755639"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 3442.68,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4B3120"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 3535.73,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#483024"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 3628.77,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#472B2A"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 3721.82,
    y: 465.228,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4B301D"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 186.092,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#422A20"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 279.136,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#7A5336"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 372.184,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#916E46"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 465.227,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#513416"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 558.271,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#453224"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 651.318,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#433326"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 744.363,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#442D1D"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 837.408,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#765238"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 930.455,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6D4D34"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 1023.5,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#473020"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 1116.55,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#453224"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 1209.59,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4B3122"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 1302.63,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#432D1F"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 1395.68,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#493125"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 1488.73,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#483224"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 1581.77,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#553924"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 1674.82,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#523620"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 1767.86,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#543520"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 1860.91,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#61412C"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 1953.96,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#553924"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 2047,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#5A3B26"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 2140.04,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#593D27"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 2233.09,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#563A25"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 2326.14,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#573824"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 2419.18,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#482E1D"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 2512.23,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4A3226"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 2605.27,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#493125"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 2698.32,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4A2C14"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 2791.37,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#714E30"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 2884.41,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#493325"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 2977.45,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#443123"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 3070.5,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#453224"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 3163.54,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#463426"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 3256.59,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#463324"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 3349.64,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4A3325"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 3442.68,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#483225"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 3535.73,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#8A674B"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 3628.77,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#976C49"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 3721.82,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#443017"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 3814.86,
    y: 558.272,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4E2D1E"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 93.0459,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4A2723"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 186.092,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9C6C46"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 279.136,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#7F5734"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 372.184,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#714C2F"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 465.227,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#95683E"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 558.271,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#986D4A"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 651.318,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#422F21"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 744.363,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#462F1D"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 837.408,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#473123"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 930.455,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#463120"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 1023.5,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#543822"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 1116.55,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6D4A2E"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 1209.59,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#63442F"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 1302.63,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#482F1B"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 1395.68,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#443323"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 1488.73,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#483024"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 1581.77,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#543823"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 1674.82,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#5A381F"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 1767.86,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#5A3A21"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 1860.91,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#704D2F"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 1953.96,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#553923"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 2047,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#5C402A"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 2140.04,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#553924"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 2233.09,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#583925"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 2326.14,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#583927"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 2419.18,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#503723"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 2512.23,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#493125"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 2605.27,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#493125"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 2698.32,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#473124"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 2791.37,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#472E18"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 2884.41,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6C4B2C"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 2977.45,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#5E422C"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 3070.5,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#453221"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 3163.54,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4C3223"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 3256.59,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4A3429"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 3349.64,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#43291A"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 3442.68,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9D6E44"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 3535.73,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#8D6238"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 3628.77,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#704C2C"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 3721.82,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#996C45"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 3814.86,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#8F6849"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 3907.91,
    y: 651.318,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#482B25"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 93.0459,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#592F23"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 186.092,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#754D29"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 279.136,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#90643F"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 372.184,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#966C44"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 465.227,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6D482D"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 558.271,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#A06A44"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 651.318,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9A7151"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 744.363,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#433022"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 837.408,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#492F20"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 930.455,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6F4F36"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 1023.5,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#442A19"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 1116.55,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4B3122"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 1209.59,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#463227"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 1302.63,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#473124"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 1395.68,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4C3225"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 1488.73,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#483123"
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 1581.77,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#573824"
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 1674.82,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#5A3721"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 1767.86,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#593B23"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 1860.91,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#755035"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 1953.96,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#583925"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 2047,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#553622"
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 2140.04,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#583C27"
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 2233.09,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#573824"
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 2326.14,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#5A3926"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 2419.18,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#573B26"
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 2512.23,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#472F23"
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 2605.27,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4B3025"
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 2698.32,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4B3025"
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 2791.37,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#473124"
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 2884.41,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#483224"
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 2977.45,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4D331C"
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 3070.5,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#745135"
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 3163.54,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4A3021"
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 3256.59,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#452F21"
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 3349.64,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9D683E"
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 3442.68,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#986D43"
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 3535.73,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#754D34"
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 3628.77,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#966642"
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 3721.82,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6E4527"
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    x: 3814.86,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#A26E49"
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 3907.91,
    y: 744.363,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#502C1C"
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#44331F"
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 93.0459,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9A6C4B"
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    x: 186.092,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6F4C2E"
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    x: 279.136,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#704523"
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    x: 372.184,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#A16C42"
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    x: 465.227,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#A0704A"
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    x: 558.271,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#714D33"
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    x: 651.318,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9D6D3F"
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    x: 744.363,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#422716"
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    x: 837.408,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#473022"
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    x: 930.455,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4C2C17"
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    x: 1023.5,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6D4D36"
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    x: 1116.55,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#432E1D"
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    x: 1209.59,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4E2D26"
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    x: 1302.63,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#483129"
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    x: 1395.68,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4A3023"
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    x: 1488.73,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#433127"
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    x: 1581.77,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#523D2A"
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    x: 1674.82,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#573722"
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    x: 1767.86,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#58381F"
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    x: 1860.91,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#583A1E"
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    x: 1953.96,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#583A22"
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    x: 2047,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#573826"
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    x: 2140.04,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#573728"
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    x: 2233.09,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#5A3B27"
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    x: 2326.14,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#593A25"
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    x: 2419.18,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#5A3928"
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    x: 2512.23,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4C3223"
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    x: 2605.27,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4B301F"
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    x: 2698.32,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4B3025"
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    x: 2791.37,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4B2E26"
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    x: 2884.41,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#44321E"
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    x: 2977.45,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4B2E1C"
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    x: 3070.5,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#452B1C"
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    x: 3163.54,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#473124"
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    x: 3256.59,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#775235"
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    x: 3349.64,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#986840"
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    x: 3442.68,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#724E2E"
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    x: 3535.73,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#A37045"
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    x: 3628.77,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#956946"
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    x: 3721.82,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9E704E"
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    x: 3814.86,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#724B2E"
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    x: 3907.91,
    y: 837.409,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4E2F1B"
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#44331F"
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    x: 93.0459,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#876343"
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    x: 186.092,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#704824"
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    x: 279.136,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6F4A30"
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    x: 372.184,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9C6D41"
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    x: 465.227,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9E6E40"
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    x: 558.271,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6F4626"
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    x: 651.318,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9E6F45"
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    x: 744.363,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#533118"
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    x: 837.408,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4A3021"
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    x: 930.455,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#452B1A"
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    x: 1023.5,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#493423"
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    x: 1116.55,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#443122"
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    x: 1209.59,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#432F26"
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    x: 1302.63,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4D2D22"
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    x: 1395.68,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4D2D22"
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    x: 1488.73,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#563C23"
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    x: 1581.77,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#563C23"
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    x: 1674.82,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#553923"
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    x: 1767.86,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#5A381D"
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    x: 1860.91,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9C6C46"
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    x: 1953.96,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9C6D41"
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    x: 2047,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9A6F42"
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    x: 2140.04,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#976D43"
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    x: 2233.09,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6C4828"
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    x: 2326.14,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#573B26"
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    x: 2419.18,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#5A3B27"
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    x: 2605.27,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#423022"
  })), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    x: 2698.32,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#463324"
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    x: 2791.37,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4B2F23"
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    x: 2884.41,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#453126"
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    x: 2977.45,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#432D18"
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    x: 3070.5,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#462D19"
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    x: 3163.54,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#443122"
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    x: 3256.59,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9F754D"
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    x: 3349.64,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#774F2C"
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    x: 3442.68,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9C6B43"
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    x: 3535.73,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#976C49"
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    x: 3628.77,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9C6F4E"
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    x: 3721.82,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9E724B"
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    x: 3814.86,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6F4B29"
  })), _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    x: 3907.91,
    y: 930.455,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4C301B"
  })), _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    x: 93.0459,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#412519"
  })), _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    x: 186.092,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9C6F48"
  })), _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    x: 279.136,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#825737"
  })), _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    x: 372.184,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#8A5E31"
  })), _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    x: 465.227,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9B6F42"
  })), _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    x: 558.271,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6D4A2A"
  })), _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    x: 651.318,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#A06F46"
  })), _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    x: 744.363,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4D2B12"
  })), _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    x: 837.408,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4B3122"
  })), _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    x: 930.455,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#45301F"
  })), _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    x: 1023.5,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#462F21"
  })), _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    x: 1116.55,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#493222"
  })), _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    x: 1209.59,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#41321F"
  })), _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    x: 1488.73,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#522C1F"
  })), _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    x: 1581.77,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#503B26"
  })), _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    x: 1674.82,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#724B2E"
  })), _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    x: 1767.86,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#A06D42"
  })), _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    x: 1860.91,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#724B2C"
  })), _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    x: 1953.96,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6E4C30"
  })), _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    x: 2047,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6E5131"
  })), _rect352 || (_rect352 = /*#__PURE__*/React.createElement("rect", {
    x: 2140.04,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#724D33"
  })), _rect353 || (_rect353 = /*#__PURE__*/React.createElement("rect", {
    x: 2233.09,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#90653B"
  })), _rect354 || (_rect354 = /*#__PURE__*/React.createElement("rect", {
    x: 2326.14,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#946C48"
  })), _rect355 || (_rect355 = /*#__PURE__*/React.createElement("rect", {
    x: 2419.18,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#583726"
  })), _rect356 || (_rect356 = /*#__PURE__*/React.createElement("rect", {
    x: 2791.37,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#54332A"
  })), _rect357 || (_rect357 = /*#__PURE__*/React.createElement("rect", {
    x: 2884.41,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#433421"
  })), _rect358 || (_rect358 = /*#__PURE__*/React.createElement("rect", {
    x: 2977.45,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#473020"
  })), _rect359 || (_rect359 = /*#__PURE__*/React.createElement("rect", {
    x: 3070.5,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#473022"
  })), _rect360 || (_rect360 = /*#__PURE__*/React.createElement("rect", {
    x: 3163.54,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#47332A"
  })), _rect361 || (_rect361 = /*#__PURE__*/React.createElement("rect", {
    x: 3256.59,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9E714A"
  })), _rect362 || (_rect362 = /*#__PURE__*/React.createElement("rect", {
    x: 3349.64,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9C6C44"
  })), _rect363 || (_rect363 = /*#__PURE__*/React.createElement("rect", {
    x: 3442.68,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#794E2C"
  })), _rect364 || (_rect364 = /*#__PURE__*/React.createElement("rect", {
    x: 3535.73,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#986C47"
  })), _rect365 || (_rect365 = /*#__PURE__*/React.createElement("rect", {
    x: 3628.77,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#926440"
  })), _rect366 || (_rect366 = /*#__PURE__*/React.createElement("rect", {
    x: 3721.82,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#A46F43"
  })), _rect367 || (_rect367 = /*#__PURE__*/React.createElement("rect", {
    x: 3814.86,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9C724A"
  })), _rect368 || (_rect368 = /*#__PURE__*/React.createElement("rect", {
    x: 3907.91,
    y: 1023.5,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#473028"
  })), _rect369 || (_rect369 = /*#__PURE__*/React.createElement("rect", {
    x: 93.0459,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4E3226"
  })), _rect370 || (_rect370 = /*#__PURE__*/React.createElement("rect", {
    x: 186.092,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#78543C"
  })), _rect371 || (_rect371 = /*#__PURE__*/React.createElement("rect", {
    x: 279.136,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#A17047"
  })), _rect372 || (_rect372 = /*#__PURE__*/React.createElement("rect", {
    x: 372.184,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#7D5532"
  })), _rect373 || (_rect373 = /*#__PURE__*/React.createElement("rect", {
    x: 465.227,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#744F32"
  })), _rect374 || (_rect374 = /*#__PURE__*/React.createElement("rect", {
    x: 558.271,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9E704C"
  })), _rect375 || (_rect375 = /*#__PURE__*/React.createElement("rect", {
    x: 651.318,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#986C49"
  })), _rect376 || (_rect376 = /*#__PURE__*/React.createElement("rect", {
    x: 744.363,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#432E1D"
  })), _rect377 || (_rect377 = /*#__PURE__*/React.createElement("rect", {
    x: 837.408,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#483322"
  })), _rect378 || (_rect378 = /*#__PURE__*/React.createElement("rect", {
    x: 930.455,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4A2E23"
  })), _rect379 || (_rect379 = /*#__PURE__*/React.createElement("rect", {
    x: 1023.5,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#422A20"
  })), _rect380 || (_rect380 = /*#__PURE__*/React.createElement("rect", {
    x: 1488.73,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#583426"
  })), _rect381 || (_rect381 = /*#__PURE__*/React.createElement("rect", {
    x: 1581.77,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#523317"
  })), _rect382 || (_rect382 = /*#__PURE__*/React.createElement("rect", {
    x: 1674.82,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#8A5C3A"
  })), _rect383 || (_rect383 = /*#__PURE__*/React.createElement("rect", {
    x: 1767.86,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6B4423"
  })), _rect384 || (_rect384 = /*#__PURE__*/React.createElement("rect", {
    x: 1860.91,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#875B36"
  })), _rect385 || (_rect385 = /*#__PURE__*/React.createElement("rect", {
    x: 1953.96,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9C6C44"
  })), _rect386 || (_rect386 = /*#__PURE__*/React.createElement("rect", {
    x: 2047,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9D6941"
  })), _rect387 || (_rect387 = /*#__PURE__*/React.createElement("rect", {
    x: 2140.04,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9F6B43"
  })), _rect388 || (_rect388 = /*#__PURE__*/React.createElement("rect", {
    x: 2233.09,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#7E5535"
  })), _rect389 || (_rect389 = /*#__PURE__*/React.createElement("rect", {
    x: 2326.14,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#946A42"
  })), _rect390 || (_rect390 = /*#__PURE__*/React.createElement("rect", {
    x: 2419.18,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#57391D"
  })), _rect391 || (_rect391 = /*#__PURE__*/React.createElement("rect", {
    x: 2977.45,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#43251D"
  })), _rect392 || (_rect392 = /*#__PURE__*/React.createElement("rect", {
    x: 3070.5,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#423620"
  })), _rect393 || (_rect393 = /*#__PURE__*/React.createElement("rect", {
    x: 3163.54,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4E3121"
  })), _rect394 || (_rect394 = /*#__PURE__*/React.createElement("rect", {
    x: 3256.59,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#49331E"
  })), _rect395 || (_rect395 = /*#__PURE__*/React.createElement("rect", {
    x: 3349.64,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9B6C42"
  })), _rect396 || (_rect396 = /*#__PURE__*/React.createElement("rect", {
    x: 3442.68,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#8A5F3C"
  })), _rect397 || (_rect397 = /*#__PURE__*/React.createElement("rect", {
    x: 3535.73,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#704D31"
  })), _rect398 || (_rect398 = /*#__PURE__*/React.createElement("rect", {
    x: 3628.77,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#704B2E"
  })), _rect399 || (_rect399 = /*#__PURE__*/React.createElement("rect", {
    x: 3721.82,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6F4E2B"
  })), _rect400 || (_rect400 = /*#__PURE__*/React.createElement("rect", {
    x: 3814.86,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#5B3522"
  })), _rect401 || (_rect401 = /*#__PURE__*/React.createElement("rect", {
    x: 3907.91,
    y: 1116.55,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4B2B20"
  })), _rect402 || (_rect402 = /*#__PURE__*/React.createElement("rect", {
    x: 186.092,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#442F1E"
  })), _rect403 || (_rect403 = /*#__PURE__*/React.createElement("rect", {
    x: 279.136,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6A4A35"
  })), _rect404 || (_rect404 = /*#__PURE__*/React.createElement("rect", {
    x: 372.184,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#815532"
  })), _rect405 || (_rect405 = /*#__PURE__*/React.createElement("rect", {
    x: 465.227,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#82522E"
  })), _rect406 || (_rect406 = /*#__PURE__*/React.createElement("rect", {
    x: 558.271,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#714A2D"
  })), _rect407 || (_rect407 = /*#__PURE__*/React.createElement("rect", {
    x: 651.318,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4A2E20"
  })), _rect408 || (_rect408 = /*#__PURE__*/React.createElement("rect", {
    x: 744.363,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#442F1E"
  })), _rect409 || (_rect409 = /*#__PURE__*/React.createElement("rect", {
    x: 837.408,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#422A20"
  })), _rect410 || (_rect410 = /*#__PURE__*/React.createElement("rect", {
    x: 1488.73,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#522C1F"
  })), _rect411 || (_rect411 = /*#__PURE__*/React.createElement("rect", {
    x: 1581.77,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9F6648"
  })), _rect412 || (_rect412 = /*#__PURE__*/React.createElement("rect", {
    x: 1674.82,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#976A41"
  })), _rect413 || (_rect413 = /*#__PURE__*/React.createElement("rect", {
    x: 1767.86,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6E492F"
  })), _rect414 || (_rect414 = /*#__PURE__*/React.createElement("rect", {
    x: 1860.91,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9B683B"
  })), _rect415 || (_rect415 = /*#__PURE__*/React.createElement("rect", {
    x: 1953.96,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6F4A2D"
  })), _rect416 || (_rect416 = /*#__PURE__*/React.createElement("rect", {
    x: 2047,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#754C2E"
  })), _rect417 || (_rect417 = /*#__PURE__*/React.createElement("rect", {
    x: 2140.04,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#714E32"
  })), _rect418 || (_rect418 = /*#__PURE__*/React.createElement("rect", {
    x: 2233.09,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#A17047"
  })), _rect419 || (_rect419 = /*#__PURE__*/React.createElement("rect", {
    x: 2326.14,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#734F2D"
  })), _rect420 || (_rect420 = /*#__PURE__*/React.createElement("rect", {
    x: 2419.18,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#634020"
  })), _rect421 || (_rect421 = /*#__PURE__*/React.createElement("rect", {
    x: 3163.54,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#432712"
  })), _rect422 || (_rect422 = /*#__PURE__*/React.createElement("rect", {
    x: 3256.59,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#432D20"
  })), _rect423 || (_rect423 = /*#__PURE__*/React.createElement("rect", {
    x: 3349.64,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4F2F1A"
  })), _rect424 || (_rect424 = /*#__PURE__*/React.createElement("rect", {
    x: 3442.68,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#794E2C"
  })), _rect425 || (_rect425 = /*#__PURE__*/React.createElement("rect", {
    x: 3535.73,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#8D5D37"
  })), _rect426 || (_rect426 = /*#__PURE__*/React.createElement("rect", {
    x: 3628.77,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#855531"
  })), _rect427 || (_rect427 = /*#__PURE__*/React.createElement("rect", {
    x: 3721.82,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#52311E"
  })), _rect428 || (_rect428 = /*#__PURE__*/React.createElement("rect", {
    x: 3814.86,
    y: 1209.59,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#3C2D1A"
  })), _rect429 || (_rect429 = /*#__PURE__*/React.createElement("rect", {
    x: 279.136,
    y: 1302.64,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4A311B"
  })), _rect430 || (_rect430 = /*#__PURE__*/React.createElement("rect", {
    x: 372.184,
    y: 1302.64,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#502B22"
  })), _rect431 || (_rect431 = /*#__PURE__*/React.createElement("rect", {
    x: 465.227,
    y: 1302.64,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#492F22"
  })), _rect432 || (_rect432 = /*#__PURE__*/React.createElement("rect", {
    x: 558.271,
    y: 1302.64,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4D2D22"
  })), _rect433 || (_rect433 = /*#__PURE__*/React.createElement("rect", {
    x: 651.318,
    y: 1302.64,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4D2D22"
  })), _rect434 || (_rect434 = /*#__PURE__*/React.createElement("rect", {
    x: 1581.77,
    y: 1302.64,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6C482E"
  })), _rect435 || (_rect435 = /*#__PURE__*/React.createElement("rect", {
    x: 1674.82,
    y: 1302.64,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#926442"
  })), _rect436 || (_rect436 = /*#__PURE__*/React.createElement("rect", {
    x: 1767.86,
    y: 1302.64,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#714E32"
  })), _rect437 || (_rect437 = /*#__PURE__*/React.createElement("rect", {
    x: 1860.91,
    y: 1302.64,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#966640"
  })), _rect438 || (_rect438 = /*#__PURE__*/React.createElement("rect", {
    x: 1953.96,
    y: 1302.64,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9B6A42"
  })), _rect439 || (_rect439 = /*#__PURE__*/React.createElement("rect", {
    x: 2047,
    y: 1302.64,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9E6D42"
  })), _rect440 || (_rect440 = /*#__PURE__*/React.createElement("rect", {
    x: 2140.04,
    y: 1302.64,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6B4629"
  })), _rect441 || (_rect441 = /*#__PURE__*/React.createElement("rect", {
    x: 2233.09,
    y: 1302.64,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9B6B43"
  })), _rect442 || (_rect442 = /*#__PURE__*/React.createElement("rect", {
    x: 2326.14,
    y: 1302.64,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#734E33"
  })), _rect443 || (_rect443 = /*#__PURE__*/React.createElement("rect", {
    x: 2419.18,
    y: 1302.64,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#5B391D"
  })), _rect444 || (_rect444 = /*#__PURE__*/React.createElement("rect", {
    x: 3349.64,
    y: 1302.64,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#453119"
  })), _rect445 || (_rect445 = /*#__PURE__*/React.createElement("rect", {
    x: 3442.68,
    y: 1302.64,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4D3020"
  })), _rect446 || (_rect446 = /*#__PURE__*/React.createElement("rect", {
    x: 3535.73,
    y: 1302.64,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4A2B28"
  })), _rect447 || (_rect447 = /*#__PURE__*/React.createElement("rect", {
    x: 3628.77,
    y: 1302.64,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4B2B20"
  })), _rect448 || (_rect448 = /*#__PURE__*/React.createElement("rect", {
    x: 3721.82,
    y: 1302.64,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4B2B20"
  })), _rect449 || (_rect449 = /*#__PURE__*/React.createElement("rect", {
    x: 1581.77,
    y: 1395.68,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#523621"
  })), _rect450 || (_rect450 = /*#__PURE__*/React.createElement("rect", {
    x: 1674.82,
    y: 1395.68,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#755131"
  })), _rect451 || (_rect451 = /*#__PURE__*/React.createElement("rect", {
    x: 1767.86,
    y: 1395.68,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9C6D43"
  })), _rect452 || (_rect452 = /*#__PURE__*/React.createElement("rect", {
    x: 1860.91,
    y: 1395.68,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6E492C"
  })), _rect453 || (_rect453 = /*#__PURE__*/React.createElement("rect", {
    x: 1953.96,
    y: 1395.68,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6F4C2E"
  })), _rect454 || (_rect454 = /*#__PURE__*/React.createElement("rect", {
    x: 2047,
    y: 1395.68,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#6E4B2D"
  })), _rect455 || (_rect455 = /*#__PURE__*/React.createElement("rect", {
    x: 2140.04,
    y: 1395.68,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#7D522F"
  })), _rect456 || (_rect456 = /*#__PURE__*/React.createElement("rect", {
    x: 2233.09,
    y: 1395.68,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#A26F44"
  })), _rect457 || (_rect457 = /*#__PURE__*/React.createElement("rect", {
    x: 2326.14,
    y: 1395.68,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#704B31"
  })), _rect458 || (_rect458 = /*#__PURE__*/React.createElement("rect", {
    x: 2419.18,
    y: 1395.68,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#543324"
  })), _rect459 || (_rect459 = /*#__PURE__*/React.createElement("rect", {
    x: 1674.82,
    y: 1488.73,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#55392B"
  })), _rect460 || (_rect460 = /*#__PURE__*/React.createElement("rect", {
    x: 1767.86,
    y: 1488.73,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#4F2D14"
  })), _rect461 || (_rect461 = /*#__PURE__*/React.createElement("rect", {
    x: 1860.91,
    y: 1488.73,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9B6C40"
  })), _rect462 || (_rect462 = /*#__PURE__*/React.createElement("rect", {
    x: 1953.96,
    y: 1488.73,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#9B7043"
  })), _rect463 || (_rect463 = /*#__PURE__*/React.createElement("rect", {
    x: 2047,
    y: 1488.73,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#A26D43"
  })), _rect464 || (_rect464 = /*#__PURE__*/React.createElement("rect", {
    x: 2140.04,
    y: 1488.73,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#986B42"
  })), _rect465 || (_rect465 = /*#__PURE__*/React.createElement("rect", {
    x: 2233.09,
    y: 1488.73,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#59351F"
  })), _rect466 || (_rect466 = /*#__PURE__*/React.createElement("rect", {
    x: 2326.14,
    y: 1488.73,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#5C3621"
  })), _rect467 || (_rect467 = /*#__PURE__*/React.createElement("rect", {
    x: 1860.91,
    y: 1581.77,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#55392B"
  })), _rect468 || (_rect468 = /*#__PURE__*/React.createElement("rect", {
    x: 1953.96,
    y: 1581.77,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#54341B"
  })), _rect469 || (_rect469 = /*#__PURE__*/React.createElement("rect", {
    x: 2047,
    y: 1581.77,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#53371F"
  })), _rect470 || (_rect470 = /*#__PURE__*/React.createElement("rect", {
    x: 2140.04,
    y: 1581.77,
    width: 93.0455,
    height: 93.0455,
    rx: 46.5227,
    fill: "#5C3621"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogs);
export default __webpack_public_path__ + "static/media/Logs.3d6a609a927a44fc006c33de9ed755c2.svg";
export { ForwardRef as ReactComponent };